import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Field, FieldArray, reduxForm, change, formValueSelector } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Button,
  FormGroup,
} from 'react-bootstrap';
import Link from '../../Link';
import Uploader from './Uploader';
import PlaceGeoSuggest from '../../Common/GeoSuggest/PlaceGeoSuggest';
import FieldArrayComponent from '../../CommonFields/FieldArrayComponent';

import submit from './submit';
import validate from './validate';
import messages from '../../../locale/jsonMessages';
import { formatLocaleData } from '../../../helpers/formatLocale';

import { GoBackArrow } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';

import cs from '../../../components/commonStyle.css';
import s from './EditPopularLocationManagement.css';
class EditPopularLocationManagement extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    initialValues: PropTypes.object,
  };

  onSuggestSelect = (data, value) => {
    const { change } = this.props;
    if (value) {
      change('locationAddress', value);
    }
  }

  onSuggestSelect = (data, value) => {
    const { change } = this.props;
    if (value) {
      change('locationAddress', value);
    }
  }

  onTextChange = (value) => {
    const { change } = this.props;
    if (value && value?.trim() === '') {
      change('locationAddress', value);
    } else {
      change('locationAddress', null);
    }
  }

  renderPlacesSuggest = ({ input, label, meta: { touched, error }, isRequiredInput }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup className={cs.noMargin}>
        <label className='commonLabelText'>{label}{isRequiredInput && <sup className='isRequiredStar'>*</sup>}</label>
        <PlaceGeoSuggest
          {...input}
          initialValue={input?.value}
          placeholder={label}
          onSuggestSelect={this.onSuggestSelect}
          onChange={this.onTextChange}
          id={'editPopular'}
          containerClassName='siteAdminPopularLocation'
        />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}

      </FormGroup>
    )
  }


  render() {
    const { error, handleSubmit, submitting, initialValues, selectedLanguage } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className='siteAdminCenterContainer'>
        <div className={cx('singleBtnFlexEnd', cs.spaceBottom4)}>
          <Link to={'/siteadmin/popularlocation'} className='goBackLink'>
            <GoBackArrow />
            <FormattedMessage  {...messages.goBack} />
          </Link>
        </div>
        <div className='siteAdminCenterContainerBox'>
          <h1 className='siteAdminHeading'><FormattedMessage  {...messages.editPopularLocation} /></h1>
          <form onSubmit={handleSubmit(submit)}>
            {error && <strong>{formatMessage(error)}</strong>}
            <div className="oneColumnGrid">
              <div className='siteAdminDropZoneWrapper'>
                <label className={cx('commonLabelText', cs.spaceBottom3)} ><FormattedMessage  {...messages.imageLabel} /></label>
                <Uploader values={initialValues} />
              </div>
              <div className={s.popularLocationDivider}>
                <Field name="locationAddress"
                  type="text"
                  component={this.renderPlacesSuggest}
                  label={formatMessage(messages.locationAddress)}
                  isRequiredInput
                />
              </div>
              <FieldArray
                name="dynamicPopularLocation"
                component={FieldArrayComponent}
                activesFields={['language', 'location']}
                filedName={"dynamicPopularLocation"}
                selectedLanguage={selectedLanguage}
              />
            </div>
            <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
              <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting} ><FormattedMessage  {...messages.save} /></Button>
            </div>
          </form>
        </div>
      </div>
    );
  }

}

EditPopularLocationManagement = reduxForm({
  form: 'EditPopularLocation', // a unique name for this form
  validate
})(EditPopularLocationManagement);

const selector = formValueSelector('EditPopularLocation');

const mapState = (state) => ({
  selectedLanguage: selector(state, 'dynamicPopularLocation'),
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(EditPopularLocationManagement)));
